import Vue from "vue";
import AddSubmissionsModal from "./modals/add_submissions.vue";

export const onAddSubmissions = ({ workspaceKey, folderId }) => {
  return new Promise((resolve) => {
    Vue.prototype.$egModal.show("add-submissions-modal", {
      component: AddSubmissionsModal,
      props: {
        workspaceKey,
        folderId,
      },
      on: {
        submitted: () => {
          resolve();
        },
      },
    });
  });
};
